import React, {
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  forwardRef,
  useId,
} from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Icon from "@mdi/react";
import { mdiCalendar } from "@mdi/js";
import "./styles.scss";
import { useDateTimeContext } from "../DateTimeContext";
import { createPortal } from "react-dom";

const DatePickerInput = forwardRef(
  ({ value, onChange, placeholder = "Pick Up Date", minDate, pickerId }, ref) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const inputRef = useRef(null);

    const { activePicker, setActivePicker } = useDateTimeContext();

    const autoId = useId();
    const PICKER_ID = pickerId || `date-${autoId}`;

    useImperativeHandle(ref, () => ({
      open: () => {
        setActivePicker(PICKER_ID);
        setOpen(true);
      },
      close: () => {
        setOpen(false);
        if (activePicker === PICKER_ID) setActivePicker(null);
      },
      toggle: () => {
        if (open) {
          setOpen(false);
          setActivePicker(null);
        } else {
          setActivePicker(PICKER_ID);
          setOpen(true);
        }
      },
    }));

    // Close if another picker becomes active
    useEffect(() => {
      if (activePicker !== PICKER_ID && open) setOpen(false);
    }, [activePicker, open, PICKER_ID]);

    useEffect(() => {
      const onDocMouseDown = (e) => {
        if (!rootRef.current) return;
        if (!rootRef.current.contains(e.target)) {
          setOpen(false);
          if (activePicker === PICKER_ID) setActivePicker(null);
        }
      };

      document.addEventListener("mousedown", onDocMouseDown);
      return () => document.removeEventListener("mousedown", onDocMouseDown);
    }, [activePicker, PICKER_ID, setActivePicker]);

    const handleClick = () => {
      setActivePicker(PICKER_ID);
      setOpen((p) => !p);
    };

    const handleDateChange = (date) => {
      onChange(date);
      setTimeout(() => {
        setOpen(false);
        setActivePicker(null);
      }, 180);
    };

    return (
      <div className="dtp-root" ref={rootRef}>
        <div
          ref={inputRef}
          className={`dtp-input ${value ? "" : "is-placeholder"}`}
          style={{ fontSize: "14px" }}
          role="button"
          tabIndex={0}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={handleClick}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") handleClick();
          }}
        >
          <span className="dtp-input__text" style={{ fontSize: "14px" }}>
          {value ? value.toLocaleDateString("en-CA") : placeholder}
          </span>
          {/* <Icon path={mdiCalendar} size={1.2} className="dtp-input__icon" /> */}
          <Icon
            path={mdiCalendar}
            size={1.2}
            color="#666"
            className="dtp-input__icon"
          />

        </div>

        {/* {open && (
          <div className="dtp-popup" onMouseDown={(e) => e.stopPropagation()}>
            <Calendar onChange={handleDateChange} value={value} minDate={minDate} />
          </div>
        )} */}
        {open &&
          rootRef.current &&
          createPortal(
            (() => {
              const rect = rootRef.current.getBoundingClientRect();

              return (
                <div
                  className="dtp-popup"
                  // style={{
                  //   position: "fixed",
                  //   top: rect.bottom + 8,
                  //   left: rect.left,
                  //   zIndex: 99999,
                  // }}
                  style={{
                    position: "absolute",
                    top: rect.bottom + window.scrollY + 8,
                    left: rect.left + window.scrollX,
                    zIndex: 99999,
                    width: "auto",
                  }}

                  onMouseDown={(e) => e.stopPropagation()}
                >
                  <Calendar
                    onChange={handleDateChange}
                    value={value}
                    minDate={minDate}
                  />
                </div>
              );
            })(),
            document.body
          )
        }


      </div>
    );
  }
);

export default DatePickerInput;
